module.exports = "./dist/assets/images/icons/d358d0e25fde9349529b54fb8dc7c417.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/testbench.png
// module id = ./assets/images/icons/testbench.png
// module chunks = 0